import { isValid as isValidFns } from 'date-fns';

export interface DateUnits {
  day?: number;
  month?: number;
  year?: number;
}

/**
 * Get the number of days in a month.
 * @param {number} month - The month.
 * @param {number} year - The year.
 * @returns {number} - The number of days in the month.
 */
export function daysInMonth(month: number, year?: number): number {
  switch (month) {
    case 2: {
      const day = (n: number) => ((n % 4 === 0 && n % 100) || n % 400 === 0 ? 29 : 28);
      return !year || year.toString().length < 4 ? 29 : day(year);
    }
    case 9:
    case 4:
    case 6:
    case 11:
      return 30;
    default:
      return 31;
  }
}

/**
 * Check if the date is valid.
 * @param {number} day - The day.
 * @param {number} month - The month.
 * @param {number} year - The year.
 * @returns {boolean} - Whether the date is valid.
 */
export function isValid(day: number, month: number, year: number): boolean {
  const date = new Date(year, month - 1, day);
  return month >= 1 && month < 13 && day > 0 && day <= daysInMonth(month, year) && isValidFns(date);
}

/**
 * Format a number to two digits.
 * @param {number} number - The number to format.
 * @returns {string} - The formatted number.
 */
export function twoDigitsNumber(number?: number): string {
  if (!number) {
    return '';
  }

  return number < 10 ? `0${number}` : number.toString();
}

/**
 * Get the capped units.
 * @param {DateUnits} units - The units.
 * @returns {DateUnits} - The capped units.
 */
export function getCappedUnits({ day, month, year }: DateUnits): DateUnits {
  const maxDays = month ? daysInMonth(month, year) : 31;

  return {
    day: day && day > maxDays ? maxDays : day,
    month: month && month > 12 ? 12 : month,
    year: year && year > 9999 ? 9999 : year,
  };
}
